
import React from 'react'
import { jobTypes, priceRanges, timeRanges } from './mock';
import {SwitchItem} from '../../@shared/elements/switcher/item'
import { SelectDropdown, SelectDropdownFilter } from '../../@shared/elements/select';

export const CategoryFilters = () =>{
    return (
        <section id='filtering'>
          

            <div className="services">
              
                <div className="selects flex-start">
                    <SelectDropdown data={timeRanges} />
                    <SelectDropdown data={jobTypes} />
                    <SelectDropdown title="15 miles" data={priceRanges} />
                </div>

     
                <ul className="switcher">
                    <SwitchItem title="Pro Services" />
                    <SwitchItem title="Online Sellers" />
                    <SwitchItem title="Subscription" />
                </ul>
            </div>
        </section>  
    )
}